export default "__VITE_ASSET__pa2YR0bG__"